import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledMessage = styled.div`
  text-align: center;
  padding: 2rem 0;
`

export const StyledDrawerWrapper = styled.div`
  z-index: 489; // Needs to be higher than navbar
  position: relative;

  ${({ isMobile }) =>
    isMobile &&
    css`
      z-index: 9999;
    `}
`

export const customHeaderStyles = css`
  background: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
`
